import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../../Enums/MagicField.enum';
import { EventCancelWithPayment } from '../Default/CaseTypeDetailFormItems';
import { Rule } from '../../../../../MagicForm/Enums/Rule.enum';

export const caseTypeDetailLatamScheme = (
	isEditable = true,
	isOnlyOneRoot: boolean,
	caseTypeId?: string,
) => {
	return [
		{
			type: MagicField.TEXT_FIELD,
			title: '',
			key: 'caseTypeId',
			settings: {
				hidden: true,
			},
		},
		{
			type: MagicField.ORGANIZATION_UNIT_SELECT,
			key: 'parentCaseTypeId',
			title: 'component.caseType.higherManagementUnit',
			settings: {
				hidden: isOnlyOneRoot,
				excludedIds: [caseTypeId],
			},
		},
		{
			type: MagicField.TEXT_FIELD,
			key: 'label',
			title: 'component.caseType.enterNameOfCaseType',
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeDetail.label',
				disabled: !isEditable,
				showCharCounter: false,
				rules: [
					{
						type: 'maxLength',
						value: 255,
						message: 'validation.form.maxLength',
					},
				],
			},
		},
		{
			type: MagicField.RADIOLIST,
			key: 'canOrderImmediate',
			title: 'component.caseType.allowEnterRequest',
			children: [
				{
					value: '0',
					title: 'base.no',
				},
				{
					value: '1',
					title: 'base.yes',
				},
			],
			inLine: true,
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeDetail.canOrderImmediate',
			},
		},
		{
			type: MagicField.RADIOLIST,
			key: 'canBook',
			title: 'component.caseType.allowOrderToCaseType',
			children: [
				{
					value: '0',
					title: 'base.no',
				},
				{
					value: '1',
					title: 'base.yes',
				},
			],
			inLine: true,
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeDetail.canBook',
			},
		},
		{
			type: MagicField.CONDITION,
			value: 'view',
			settings: {
				rules: [
					{
						formControlKey: 'canBook',
						rule: 'equal',
						value: '1',
					},
				],
			},
			children: [
				{
					type: MagicField.CONTAINER,
					settings: {
						showLine: true,
					},
					children: [
						{
							type: MagicField.RADIOLIST,
							key: 'notificationBook',
							title: 'component.caseType.notificationBook',
							children: [
								{
									value: '0',
									title: 'base.no',
								},
								{
									value: '1',
									title: 'base.yes',
								},
							],
							inLine: true,
							settings: {
								required: true,
								errorMessage: 'validation.caseTypeDetail.notificationBook',
							},
						},
						{
							type: MagicField.TEXT,
							subType: 'label',
							title:
								'component.caseTypeDetail.thePatientCanMakeAnAppointmentAt',
							settings: {
								firstUpper: true,
							},
						},
						{
							type: MagicField.CHECKBOX,
							key: 'canBookOnline',
							title: 'component.eventCalendar.onlineConsultation',
							settings: {
								firstUpper: true,
							},
						},
						{
							type: MagicField.CHECKBOX,
							key: 'canBookOnSite',
							title: 'base.presentConsultation',
							settings: {
								firstUpper: true,
								requiredRules: [
									{
										formControlKey: 'canBook',
										rule: Rule.EQUAL,
										value: '1',
										groupKeys: ['canBookOnline', 'canBookOnSite'],
									},
								],
								errorMessage:
									'validation.caseTypeDetail.atLeastOneBookRequired',
							},
						},
						{
							type: MagicField.TEXT_FIELD,
							subType: 'number',
							key: 'eventInterval',
							title: 'base.timeSubsidyOfCaseType',
							settings: {
								suffix: 'base.minutes2',
								required: true,
								errorMessage: 'validation.caseTypeDetail.eventInterval',
							},
						},
					],
				},
			],
		},
		{
			type: MagicField.PRICE_WITH_CURRENCY,
			key: 'price',
			title: 'component.caseType.priceOfCaseType2',
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeDetail.price',
				allowZero: true,
			},
		},
		{
			type: MagicField.VAT_RATE,
			key: 'vatRate',
			title: 'component.caseType.vatRate',
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeDetail.vatRate',
			},
		},
		//EventCancelWithPayment,
		{
			type: MagicField.RADIOLIST,
			key: 'isWithDoc',
			title: 'component.caseType.isWithDoc',
			children: [
				{
					value: '0',
					title: 'base.no',
				},
				{
					value: '1',
					title: 'base.yes',
				},
			],
			inLine: true,
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeDetail.isWithDoc',
			},
		},
		{
			type: MagicField.CONDITION,
			value: 'view',
			settings: {
				rules: [
					{
						formControlKey: 'isWithDoc',
						rule: 'equal',
						value: '1',
					},
				],
			},
			children: [
				{
					type: MagicField.CONTAINER,
					settings: {
						showLine: true,
					},
					children: [
						{
							type: MagicField.TEXT_FIELD,
							title: '',
							key: 'docId',
							settings: {
								hidden: true,
							},
						},
						{
							type: MagicField.TEXT_FIELD,
							key: 'docName',
							title: 'component.caseType.docName',
							settings: {
								required: true,
								errorMessage: 'validation.caseTypeDetail.docName',
							},
						},
						{
							type: MagicField.RADIOLIST,
							key: 'docRequired',
							title: 'component.caseType.docRequired',
							children: [
								{
									value: '0',
									title: 'base.no',
								},
								{
									value: '1',
									title: 'base.yes',
								},
							],
							inLine: true,
							settings: {
								required: true,
								errorMessage: 'validation.caseTypeDetail.docRequired',
							},
						},
					],
				},
			],
		},
		{
			type: MagicField.RADIOLIST,
			key: 'isWithAnswer',
			title: 'component.caseType.isWithAnswer',
			children: [
				{
					value: '0',
					title: 'base.no',
				},
				{
					value: '1',
					title: 'base.yes',
				},
			],
			inLine: true,
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeDetail.isWithAnswer',
			},
		},
		{
			type: MagicField.CONDITION,
			value: 'view',
			settings: {
				rules: [
					{
						formControlKey: 'isWithAnswer',
						rule: 'equal',
						value: '1',
					},
				],
			},
			children: [
				{
					type: MagicField.CONTAINER,
					settings: {
						showLine: true,
					},
					children: [
						{
							type: MagicField.TEXT_FIELD,
							title: '',
							key: 'answerId',
							settings: {
								hidden: true,
							},
						},
						{
							type: MagicField.TEXT_FIELD,
							key: 'answerName',
							title: 'component.caseType.answerName',
							settings: {
								required: true,
								errorMessage: 'validation.caseTypeDetail.answerName',
							},
						},
						{
							type: MagicField.RADIOLIST,
							key: 'answerRequired',
							title: 'component.caseType.answerRequired',
							children: [
								{
									value: '0',
									title: 'base.no',
								},
								{
									value: '1',
									title: 'base.yes',
								},
							],
							inLine: true,
							settings: {
								required: true,
								errorMessage: 'validation.caseTypeDetail.answerRequired',
							},
						},
					],
				},
			],
		},
		{
			type: MagicField.RADIOLIST,
			key: 'isWithTextInformation',
			title: 'component.caseType.isWithTextInformation',
			children: [
				{
					value: '0',
					title: 'base.no',
				},
				{
					value: '1',
					title: 'base.yes',
				},
			],
			inLine: true,
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeDetail.isWithTextInformation',
			},
		},
		{
			type: MagicField.CONDITION,
			value: 'view',
			settings: {
				rules: [
					{
						formControlKey: 'isWithTextInformation',
						rule: 'equal',
						value: '1',
					},
				],
			},
			children: [
				{
					type: MagicField.CONTAINER,
					settings: {
						showLine: true,
					},
					children: [
						{
							type: MagicField.TEXT_FIELD,
							title: '',
							key: 'textInformationId',
							settings: {
								hidden: true,
							},
						},
						{
							type: MagicField.TEXT_FIELD,
							key: 'textInformation',
							title: 'component.caseType.textInformation',
							settings: {
								required: true,
								errorMessage: 'validation.caseTypeDetail.textInformation',
							},
						},
					],
				},
			],
		},
	] as ItemScheme[];
};
